import { useState } from 'react';

import { Box, CSSProperties } from '@bcp-nextgen-dx-component-factory/design-system';

interface ImageWithBackgroundProps {
	imageSrc?: string;
	background?: string;
	styles?: CSSProperties;
}

export const ImageWithBackground = ({ imageSrc, background, styles }: ImageWithBackgroundProps) => {
	const [imageLoaded, setImageLoaded] = useState(false);
	const [imageError, setImageError] = useState(false);

	const handleImageLoad = () => {
		setImageLoaded(true);
	};

	const handleImageError = () => {
		setImageError(true);
	};

	const backgroundImageStyle = {
		background,
		display: imageLoaded && !imageError ? 'none' : 'block',
	};

	const imageStyle = {
		display: imageLoaded && !imageError ? 'block' : 'none',
	};

	return (
		<Box
			styles={{
				position: 'absolute',
				top: 0,
				right: 0,
				bottom: 0,
				left: 0,
				width: '100%',
				height: '100%',
				overflow: 'hidden',
				zIndex: -1,
				...styles,
			}}
		>
			<Box styles={{ ...backgroundImageStyle, position: 'absolute', width: '100%', height: '100%' }} />
			<img
				src={imageSrc}
				alt=""
				style={{ ...imageStyle, position: 'absolute', width: '100%', height: '100%', objectFit: 'cover' }}
				onLoad={handleImageLoad}
				onError={handleImageError}
			/>
		</Box>
	);
};
